const ProjectsData = [
    {
        id: 0,
        title: 'جامعة الاميرة نورة - الرياض',
        description: "من أميز المشاريع التي نعمل عليها مشاريع المساجد و الجوامع حيث تتميز بطارز إسلامي رائع ، وكان جامع الصالح بصنعاء من ضمن تلك المشاريع.",
        img: require("../../Assets/project01.jpg")
    },
    {
        id: 1,
        title: 'جامعة الامام محمد بن سعود',
        description: "من أميز المشاريع التي نعمل عليها مشاريع المساجد و الجوامع حيث تتميز بطارز إسلامي رائع ، وكان جامع الصالح بصنعاء من ضمن تلك المشاريع.",
        img: require("../../Assets/project02.jpg")
    },
    {
        id: 2,
        title: 'جامعة ام القرى - الرياض',
        description: "من أميز المشاريع التي نعمل عليها مشاريع المساجد و الجوامع حيث تتميز بطارز إسلامي رائع ، وكان جامع الصالح بصنعاء من ضمن تلك المشاريع.",
        img: require("../../Assets/project03.jpg")
    },
    {
        id: 3,
        title: 'جامعة حائل - حائل',
        description: "من أميز المشاريع التي نعمل عليها مشاريع المساجد و الجوامع حيث تتميز بطارز إسلامي رائع ، وكان جامع الصالح بصنعاء من ضمن تلك المشاريع.",
        img: require("../../Assets/project04.jpg")
    },
    {
        id: 4,
        title: 'مركز الملك عبدالله للدراسات البترولية',
        description: "من أميز المشاريع التي نعمل عليها مشاريع المساجد و الجوامع حيث تتميز بطارز إسلامي رائع ، وكان جامع الصالح بصنعاء من ضمن تلك المشاريع.",
        img: require("../../Assets/project05.jpg")
    },
    {
        id: 5,
        title: 'قطار المشاعر - مكة المكرمة',
        description: "من أميز المشاريع التي نعمل عليها مشاريع المساجد و الجوامع حيث تتميز بطارز إسلامي رائع ، وكان جامع الصالح بصنعاء من ضمن تلك المشاريع.",
        img: require("../../Assets/project06.png")
    },
]

export default ProjectsData;